module.exports = __webpack_public_path__ + "static/home-hero-bg-light-1df9200c21c39a72c09a3b756f861ce2.png";